import { useEffect } from "react";

const JaneFrame: React.FC<{
  onPostMessage: (event: MessageEvent) => void;
  janeCheckoutUrl: string;
  loading: boolean;
}> = ({ onPostMessage, janeCheckoutUrl, loading }) => {
  useEffect(() => {
    const onLoad = () => {
      window.addEventListener("message", onPostMessage, false);
    };
    const script = document.createElement("script");
    script.id = "jane-frame-script";
    script.src = janeCheckoutUrl;
    script.setAttribute("data-testid", "jane-frame-script");
    script.onload = onLoad;
    const div = document.querySelector("#janeCheckout");
    if (div) {
      div.appendChild(script);
    }
    return () => {
      window.removeEventListener("message", onPostMessage);
      if (div) {
        div.removeChild(script);
      }
    };
  }, []);

  return (
    <div>
      <div hidden={loading} id="janeCheckout"></div>
      <div hidden={!loading} className="p-xxl">
        <div className="loader"></div>
      </div>
    </div>
  );
};

export default JaneFrame;
